import { createDocumentPage, getDocumentTextForType } from "./documentBaseUtils";

export function generatePrintLicensingRenewalHtml(config, data, user, breakNewPage = false) {
    const { getDocumentText } = getDocumentTextForType(data, config);
    return createDocumentPage({title: 'DECLARAÇÃO', documentText: getDocumentText('RENOVACAO_LICENCIAMENTO'), config, data, user}, {showUserName: true, breakNewPage: breakNewPage});
}
